import { Component, OnInit } from '@angular/core';

import { Page } from '../../helpers/page';

import { AuthService } from '../../services/auth.service';
import { DocsService } from '../../services/docs.service';

@Component({
    selector: 'kd-document-lock',
    templateUrl: './document-lock.component.html',
    styleUrls: ['./document-lock.component.scss']
})
export class DocumentLockComponent implements OnInit {

    private id: string;
    private isPublic: boolean;

    constructor(
        private authService: AuthService,
        private docsService: DocsService,
    ) { }

    ngOnInit() {
        const page: Page = this.docsService.getPage();
        this.id = page.id;
        this.isPublic = page.is_public;
    }

    canLock(): boolean {
        return this.isStaff() && this.isPublic;
    }

    isLocked(): boolean {
        return !this.isPublic;
    }

    private isStaff(): boolean {
        return this.authService.isAuthorized() && this.authService.getAccount().is_staff;
    }

    async toggleVisibility(): Promise<void> {
        if (this.isStaff()) {
            this.isPublic = await this.docsService.toggleVisibility(this.id, this.isPublic);
        }
    }
}
